import './index.scss';
import React, { ChangeEvent } from 'react';
import { Tooltip } from '@umu/umu-design';
import { Loading } from 'common/src/components';
export interface ITransferData {
    key: string;
    tooltipDesc?: string | JSX.Element;
    title: string | JSX.Element;
    disabled?: boolean;
    info?: any;
}

export interface ITransfer {
    className?: string;
    title?: string | JSX.Element;
    data?: ITransferData[];
    defaultValue?: string;
    isEditor?: boolean;
    textPlaceholder?: string;
    tooltipProps?: any;
    isLoading?: boolean;
    onChange?: (val: string) => void;
}
const overlayInnerStyle = {
    lineHeight: '0.2rem',
    color: '#222222',
    fontSize: '0.14rem',
};
export const TransformInput = (props: ITransfer) => {
    const {
        title,
        className = '',
        data = [],
        isLoading = false,
        tooltipProps = {},
        isEditor = false,
        textPlaceholder = '',
        onChange,
        defaultValue = '',
    } = props;
    const onTextareaChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        if (onChange) {
            onChange(event.target.value || '');
        }
    };
    const renderList = () => {
        if (isLoading) {
            return <Loading className="transfer-item-loading" />;
        }
        return (
            <ul>
                {data.map((item: ITransferData) => (
                    <li key={`transfer-item-${item.key}`}>
                        <Tooltip
                            title={item.tooltipDesc}
                            placement="bottom"
                            zIndex={9999}
                            overlayInnerStyle={overlayInnerStyle}
                            {...tooltipProps}
                        >
                            {item.title}
                        </Tooltip>
                    </li>
                ))}
            </ul>
        );
    };
    const renderZoneContent = () => {
        return isEditor ? (
            <textarea placeholder={textPlaceholder} onChange={onTextareaChange} value={defaultValue}></textarea>
        ) : (
            renderList()
        );
    };
    return (
        <div className={`umu-batch-add-account-transfer-zone ${className}`}>
            <div className="transfer-title">{title}</div>
            <div className="transfer-zone">{renderZoneContent()}</div>
        </div>
    );
};
